import { OktaAuth } from '@okta/okta-auth-js';
import axios from 'axios';
import { getEnv } from '../config/OktaConfig';

export class SizeService {

    private oktaAuth: OktaAuth;
    private host: string;

    constructor(oktaAuth: OktaAuth) {
        this.oktaAuth = oktaAuth;
        this.host = getEnv('REACT_APP_PRODUCT_WEIGHTS_HOST') ?? 'https://dummygraphql.com';
    }

    async getSizesByProductCode(productCode: string): Promise<any> {
        const accessToken = await this.oktaAuth.getAccessToken();
        
        return await axios.get(
            `${this.host}/api/weight/${productCode}`,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            }
        );
    }

    async storeProductSize(produceSize: any): Promise<any> {
        const accessToken = await this.oktaAuth.getAccessToken();
        
        return await axios.post(
            `${this.host}/api/weight/correction`,
            produceSize,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            }
        );
    }

    async checkProductExists(productCode: string): Promise<boolean> {
        const accessToken = await this.oktaAuth.getAccessToken();

        const response = await axios.get(
            `${this.host}/api/product/${productCode}/exists`,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                validateStatus: (status) => status === 204 || status === 404,
            }
        );

        return response.status === 204;
    }

}


